import React, { useState, useEffect } from 'react';
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseurladdress } from "../baseurl";
import $ from 'jquery';
import { Modal, ModalFooter } from "react-bootstrap";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";

function Programs({ refresh }) {
  const programModalStyles = `
    .programs-modal .modal-dialog {
      margin: 1rem auto !important;
      max-width: min(95vw, 900px);
      min-height: auto;
      display: block;
      position: relative;
      top: auto !important;
      transform: none !important;
      align-items: initial;
    }

    .programs-modal {
      overflow-y: auto;
      -ms-overflow-style: none;
      scrollbar-width: none;
    }

    .programs-modal::-webkit-scrollbar {
      width: 0;
      height: 0;
      display: none;
    }

    .programs-modal .modal-content {
      width: 100%;
      max-height: none;
      overflow: hidden;
      margin-top: 0;
    }

    .programs-modal .modal-body {
      padding: 1rem;
    }

    .programs-modal .modal-close {
      background: transparent;
      border: 0;
      color: #000;
      cursor: pointer;
      font-size: 1.5rem;
      font-weight: 400;
      line-height: 1;
      padding: 0;
      margin-left: auto;
    }

    .programs-modal .program-tree-row {
      gap: 0.75rem;
      flex-wrap: wrap;
    }

    .programs-modal .program-tree-item {
      min-width: 0;
    }

    @media (max-width: 767.98px) {
      .programs-modal .modal-dialog {
        margin: 0.5rem auto !important;
        max-width: calc(100vw - 1rem);
        min-height: auto;
      }

      .programs-modal .program-tree-row {
        flex-direction: column;
        gap: 0.5rem;
      }

      .programs-modal .program-tree-item {
        width: 100% !important;
        padding-left: 1rem !important;
      }
    }
  `;

  const [data, setData] = useState([]);
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState("");
  const [showModal, setShowModal] = useState(false);
  const accesstoken = localStorage.getItem("token");
  const navigate = useNavigate();
  const [checkedItems, setCheckedItems] = useState({});
  const Swal = require('sweetalert2')
  const accessuserid = localStorage.getItem("id");
  const [programs, setPrograms] = useState([]);
  const [loading, setLoading] = useState(true);

  const [editshowModal, seteditshowModal] = useState(false);
  const [pgmId, setpgmId] = useState("");

  const [edselectedRole, setedSelectedRole] = useState("");
  const [edSelectedRolename, setedSelectedRolename] = useState("");
  const [refreshSidebar, setRefreshSidebar] = useState(false);

  const handleRefreshSidebar = () => {
    setRefreshSidebar(prev => !prev); // Toggle to trigger refresh
  };
  useEffect(() => {
    setTimeout(() => {
      $('#programs').DataTable();
    }, 1000);
  }, []);

  const handleclick = () => {
    setShowModal(true);
    GetAllmenu();
  };

  // Fetch roles 
  useEffect(() => {
    axios.get(`${baseurladdress}findroles`, {
      headers: { Authorization: `Bearer ${accesstoken}` },
    })
      .then(res => setRoles(res.data.response))
      .catch(error => alert("Failed to fetch roles."));
  }, []);

  const GetAllmenu = () => {
    axios.get(`${baseurladdress}getprogramtree`, {
      headers: { Authorization: `Bearer ${accesstoken}` },
    })
      .then(res => {
        console.log("Program Tree:", res.data.response);
        setData(res.data.response || []);
      })
      .catch(error => {
        console.error("Failed to fetch menu tree:", error);
        alert("Failed to fetch menu tree.");
      });
  };

  function chunkArray(arr, size) {
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  }

  const handleCheckboxChange = (pgmId, isChecked, isParent = false) => {
    const newCheckedItems = { ...checkedItems, [pgmId]: isChecked };
    if (isParent) {
      data.forEach((item) => {
        if (item.pgm_parent === pgmId) {
          newCheckedItems[item.pgm_id] = isChecked;
        }
      });
    }
    setCheckedItems(newCheckedItems);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const selectedProgramIds = Object.keys(checkedItems).filter((key) => checkedItems[key]);
    if (!selectedRole) {
      alert("Please select a role");
      return;
    }
    if (selectedProgramIds.length === 0) {
      alert("Please select at least one program");
      return;
    }
    const selectedProgramNames = selectedProgramIds
      .map((id) => {
        const match = data.find((item) => item.pgm_id.toString() === id.toString());
        return match ? match.pgm_menu : null;
      })
      .filter(Boolean);
    const payload = {
      userpgm_pgm: selectedRole,
      userpgm_programs: selectedProgramIds.join(","),
      userpgm_program_names: selectedProgramNames.join(","),
      userpgm_crtdby: accessuserid,
    };
    console.log("Sending payload:", payload);
    axios
      .post(baseurladdress + `addprogram`, payload, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then((res) => {
        if (res.data.status === "success") {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: "Programs added successfully",
            showConfirmButton: false,
            timer: 2500,
          });
          handleRefreshSidebar();

          setSelectedRole("");
          setCheckedItems({});
          setShowModal(false);
          fetchPrograms();
        } else if (res.data.status === "exists") {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "warning",
            title: "Programs already exist for this role",
            showConfirmButton: false,
            timer: 2500,
          });
        } else {
          alert("Failed to save program access. " + (res.data.message || ""));
        }
      })
      .catch((error) => {
        console.error("Save error:", error);
        alert("An error occurred while saving.");
      });
  };

  const fetchPrograms = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(baseurladdress + `findallprogram`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data.response) {
        setPrograms(response.data.response);
      } else {
        console.error("No programs found");
      }
    } catch (err) {
      console.error("Error fetching programs", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPrograms();
  }, [refresh]);

  $(function () {
    setTimeout(function () {
      $('#programs').DataTable();
    }, 1000);
  });

  const handleeditclick = (pgmId) => {
    seteditshowModal(true);
    setpgmId(pgmId);
    GetAllmenu();
    axios
      .get(baseurladdress + `editpgm/` + pgmId, {
        headers: { Authorization: `Bearer ${accesstoken}` },
      })
      .then((res) => {
        const data = res.data.response[0];
        setedSelectedRole(data.userpgm_pgm);
        // Pre-check checkboxes
        const selectedProgramIds = data.userpgm_programs.split(",");
        const checked = {};
        selectedProgramIds.forEach((id) => {
          checked[id] = true;
        });
        setCheckedItems(checked);
      })
      .catch((error) => {
        alert("Failed to fetch program data for editing");
        console.error(error);
      });
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    const selectedProgramIds = Object.keys(checkedItems).filter((key) => checkedItems[key]);
    if (!edselectedRole) {
      alert("Please select a role");
      return;
    }
    if (selectedProgramIds.length === 0) {
      alert("Please select at least one program");
      return;
    }
    const selectedProgramNames = selectedProgramIds
      .map((id) => {
        const match = data.find((item) => item.pgm_id.toString() === id.toString());
        return match ? match.pgm_menu : null;
      })
      .filter(Boolean);
    const payload = {
      userpgm_id: pgmId,
      userpgm_pgm: edselectedRole,
      userpgm_programs: selectedProgramIds.join(","),
      userpgm_program_names: selectedProgramNames.join(","),
      userpgm_updby: accessuserid,
    };
    console.log("Updating payload:", payload);
    axios
      .post(baseurladdress + `updateprogram`, payload, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then((res) => {
        if (res.data.status === "success") {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: "Programs updated successfully",
            showConfirmButton: false,
            timer: 2500,
          });
          handleRefreshSidebar();

          seteditshowModal(false);
          setCheckedItems({});
          setedSelectedRole("");
          fetchPrograms();
        } else {
          alert("Update failed. " + (res.data.message || ""));
        }
      })
      .catch((error) => {
        console.error("Update error:", error);
        alert("An error occurred while updating.");
      });
  };

  function handleDelete(pgmId) {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085D6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        {
          axios
            .post(baseurladdress + `deleteprogram/` + pgmId, data, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            })
            .then((result) => {
              console.log("reslt:", result);
              const Data = result.data.status;
              if (Data == "deleted") {
                const Toast = Swal.mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 2500,
                  timerProgressBar: true,
                  didOpen: (toast) => {
                    toast.addEventListener("mouseenter", Swal.stopTimer);
                    toast.addEventListener("mouseleave", Swal.resumeTimer);
                  },
                });
                Toast.fire({
                  icon: "success",
                  title: "User data Deleted Successfully",
                });
                fetchPrograms();
              }
            });
        }
      }
    });
  }
  return (
    <div>
      <style>{programModalStyles}</style>
      <Topnavbar />
      <Sidennav refresh={refreshSidebar} />
      <div className="content-wrap">
        <div className="main">
          <div className="container-fluid">
            <section id="main-content">
              <div className="card">
                <div className="card-header" style={{ color: "black" }}>
                  <h6 className="card-title">PROGRAM DETAILS</h6>
                  <div className="d-flex align-items-center">
                    <button
                      type="button"
                      className="btn plus-icon d-flex align-items-center"
                      style={{ marginRight: '50px' }}
                      onClick={handleclick}
                    >
                      <span style={{ fontSize: "1.2rem" }}>
                        <i className='fa fa-plus-circle text-success'></i>
                      </span>
                      <span style={{ fontSize: "0.7rem", color: "black", padding: "5px" }}>
                        Add
                      </span>
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="col-lg-12">
                    <div className="card">
                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table table-bordered table-responsive-sm" id="programs">
                            <thead className='text-center'>
                              <tr>
                                <th>Sl.No</th>
                                <th>Role Name</th>
                                <th>Status</th>
                                <th>Edit</th>
                                <th>Delete</th>
                              </tr>
                            </thead>
                            <tbody>
                              {programs.map((program, index) => (
                                <tr key={program.userpgm_id || index}>
                                  <td>{index + 1}</td>
                                  <td>{program.role_name}</td>
                                  <td><div>
                                    {(() => {
                                      if (program.userpgm_status == 0) {
                                        return (
                                          <div>
                                            <span class="badge bg-danger" >
                                              Inactive
                                            </span>
                                          </div>
                                        );
                                      } else if (program.userpgm_status == 1) {
                                        return (
                                          <div><span class="badge bg-success">Active</span></div>
                                        )
                                      }
                                    })()}
                                  </div></td>
                                  <td style={{ textAlign: "center" }}>
                                    <i
                                      class="text-primary fa fa-edit"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => handleeditclick(program.userpgm_id)}
                                    ></i>
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    <i
                                      class="text-danger fa fa-trash"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => handleDelete(program.userpgm_id)}
                                    ></i>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Modal */}
                <Modal
                  className="modal-size md modal-top-center programs-modal"
                  show={showModal}
                  size="lg"
                  scrollable
                  onHide={() => setShowModal(false)}
                >
                  <Modal.Header>
                    <h6>ADD PROGRAMS</h6>
                    <button
                      type="button"
                      className="modal-close"
                      aria-label="Close"
                      onClick={() => setShowModal(false)}
                    >
                      &times;
                    </button>
                  </Modal.Header>

                  <Modal.Body>
                    <form>
                      <div className="row">
                        <div className="col-md-12">
                          <h6>Role Name</h6>
                          <select
                            className="form-control select"
                            name="role"
                            value={selectedRole}
                            onChange={(e) => setSelectedRole(e.target.value)}
                            required
                          >
                            <option value="" disabled>Select</option>
                            {roles.map((item) => (
                              <option key={item.role_id} value={item.role_id}>
                                {item.role_name}
                              </option>
                            ))}
                          </select>
                        </div>

                        {/* Program Tree Display */}
                        {data.length > 0 && (
                          <div className="mt-4 col-md-12">
                            <h6>Program Menus</h6>
                            <ul style={{ listStyle: "none", paddingLeft: 0 }}>
                              {/* Depth 0 - main parents */}
                              {data
                                .filter((item) => item.seq.split("_").length - 1 === 0)
                                .map((parent) => (
                                  <li key={parent.pgm_id} style={{ fontWeight: "bold", color: "blue" }}>
                                    <input
                                      type="checkbox"
                                      checked={checkedItems[parent.pgm_id] || false}
                                      onChange={(e) =>
                                        handleCheckboxChange(parent.pgm_id, e.target.checked, true)
                                      }
                                      style={{ marginRight: "0.5rem" }}
                                      value={parent.pgm_id}
                                      name="myArray[]"
                                    />
                                    <span>{parent.pgm_menu}</span>
                                    {/* Depth 1 children grouped in rows */}
                                    <div className="ml-4 mt-2">
                                      {chunkArray(
                                        data.filter(
                                          (item) =>
                                            item.pgm_parent === parent.pgm_id &&
                                            item.seq.split("_").length - 1 === 1
                                        ),
                                        2
                                      ).map((row, rowIndex) => (
                                        <div className="d-flex program-tree-row" key={rowIndex}>
                                          {row.map((child) => (
                                            <div
                                              key={child.pgm_id}
                                              className="d-flex align-items-center program-tree-item"
                                              style={{
                                                flex: 1,
                                                paddingLeft: "2rem",
                                                color: "purple",
                                                textTransform: "capitalize",
                                              }}
                                            >
                                              <input
                                                type="checkbox"
                                                checked={checkedItems[child.pgm_id] || false}
                                                onChange={(e) =>
                                                  handleCheckboxChange(child.pgm_id, e.target.checked)
                                                }
                                                style={{ marginRight: "0.5rem" }}
                                                value={child.pgm_id}
                                                name="myArray[]"
                                              />
                                              <span>{child.pgm_menu}</span>
                                            </div>
                                          ))}
                                        </div>
                                      ))}
                                    </div>
                                  </li>
                                ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    </form>
                  </Modal.Body>
                  <ModalFooter>
                    <div className="row w-100">
                      <div className="col-auto ml-auto">
                        <button type="button" className="btn btn-primary" id='save' onClick={handleSubmit}>
                          SAVE
                        </button>
                      </div>
                    </div>
                  </ModalFooter>
                </Modal>

                {/* Edit Modal */}
                <Modal
                  className="modal-size md modal-top-center programs-modal"
                  show={editshowModal}
                  size="lg"
                  scrollable
                  onHide={() => seteditshowModal(false)}
                >
                  <Modal.Header>
                    <h6>EDIT PROGRAMS</h6>
                    <button
                      type="button"
                      className="modal-close"
                      aria-label="Close"
                      onClick={() => seteditshowModal(false)}
                    >
                      &times;
                    </button>
                  </Modal.Header>


                  <Modal.Body>
                    <form>
                      <div className="row">
                        <div className="col-md-12">
                          <h6>Role Name</h6>
                          <select
                            className="form-control select"
                            name="role"
                            value={edselectedRole}
                            onChange={(e) => {
                              const selectedId = e.target.value;
                              const selectedItem = roles.find(item => item.role_id == selectedId);
                              setedSelectedRole(selectedId);
                              setedSelectedRolename(selectedItem ? selectedItem.role_name : "");
                            }}
                            required
                          >
                            <option value="" disabled>Select</option>
                            {roles.map(item => (
                              <option key={item.role_id} value={item.role_id}>
                                {item.role_name}
                              </option>
                            ))}
                          </select>

                        </div>

                        {data.length > 0 && (
                          <div className="mt-4 col-md-12">
                            <h6 className="text-muted">Program Menus</h6>
                            <ul style={{ listStyle: "none", paddingLeft: 0 }}>
                              {data
                                .filter((item) => item.seq.split("_").length - 1 === 0) // Level 0 (e.g., Main Menu)
                                .map((parent) => (
                                  <li key={parent.pgm_id} style={{ fontWeight: "bold", color: "blue" }}>
                                    <label>
                                      <input
                                        type="checkbox"
                                        checked={checkedItems[parent.pgm_id] || false}
                                        onChange={(e) =>
                                          handleCheckboxChange(parent.pgm_id, e.target.checked, true)
                                        }
                                        style={{ marginRight: "0.5rem" }}
                                        value={parent.pgm_id}
                                        name="myArray[]"
                                      />
                                      {parent.pgm_menu}
                                    </label>

                                    {/* Level 1 children */}
                                    <div className="ml-4 mt-2">
                                      {chunkArray(
                                        data.filter(
                                          (item) =>
                                            item.pgm_parent === parent.pgm_id &&
                                            item.seq.split("_").length - 1 === 1
                                        ),
                                        2
                                      ).map((row, rowIndex) => (
                                        <div className="d-flex mb-2 program-tree-row" key={rowIndex}>
                                          {row.map((child) => (
                                            <div
                                              key={child.pgm_id}
                                              className="d-flex align-items-center program-tree-item"
                                              style={{
                                                flex: 1,
                                                paddingLeft: "2rem",
                                                color: "purple",
                                                textTransform: "capitalize",
                                                fontWeight: "normal",
                                              }}
                                            >
                                              <input
                                                type="checkbox"
                                                checked={checkedItems[child.pgm_id] || false}
                                                onChange={(e) =>
                                                  handleCheckboxChange(child.pgm_id, e.target.checked)
                                                }
                                                style={{ marginRight: "0.5rem" }}
                                                value={child.pgm_id}
                                                name="myArray[]"
                                              />
                                              {child.pgm_menu}
                                            </div>
                                          ))}
                                        </div>
                                      ))}
                                    </div>
                                  </li>
                                ))}
                            </ul>
                          </div>
                        )}


                      </div>
                    </form>
                  </Modal.Body>
                  <ModalFooter>
                    <div className="row w-100">
                      <div className="col-auto ml-auto">
                        <button type="button" className="btn btn-primary" id='update' onClick={handleUpdate} >
                          UPDATE
                        </button>
                      </div>
                    </div>
                  </ModalFooter>
                </Modal>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Programs;
